<template>
  <div>
    <div class="submenu">
      <ul>
        <router-link tag="li" to="/scenarion">Visa alla scenarion</router-link>
        <router-link tag="li" to="/scenarion/ny">Skapa nytt scenario</router-link>
      </ul>
      <div class="clear"></div>
    </div>
            
    <div class="form">
      <div class="item">
        <div class="label">Namn</div>
        <div><input type="text" v-model="name" placeholder="Namn"></div>
      </div>
      
      <div class="item">
        <div class="label">Färg på scenario</div>
        <slider-picker style="width:100%;margin-top:20px;margin-bottom:10px;" v-model="color" />
        <div class="descr">Du väljer en färg på scenariot för att göra det lite mer personligt.</div>
      </div>
      
      <div class="item">
        <div class="label">Ikoner</div>
        
        <button @click="showIcons = !showIcons">{{ showIcons ? 'Dölj ikoner' : 'Visa ikoner' }}</button>
        
        <div class="bootstrap-wrapper" v-if="showIcons">
          <hr class="space">
          
          <div class="container">
            <div class="row">
              <div class="col-md-1" v-for="icon in icons" style="margin-bottom:12px;" @click="(selectedIcon === icon ? selectedIcon = '' : selectedIcon = icon)">
                <div :style="iconStyle(icon)">
                 <img :src="icon" width="100%" height="100%" style="object-fit:contain;">
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="descr" v-if="!showIcons">Tryck på knappen ovanför för att visa tillgängliga ikoner, tryck sedan på en ikon för att välja den.</div>
      </div>
            
      <div class="item">
        <div class="label">Kommandon</div>
        <commands-view :commands="commands"></commands-view>
      </div>
      
      <div class="item">
        <button @click="save" :disabled="!ok"><span v-if="!saving">Spara scenariot</span><span v-else>Sparar...</span></button>
      </div>
            
      <div class="item" v-if="editing">
        <button @click="remove" class="red">Radera scenario</button>
      </div>
    </div>    
        
  </div>
</template>

<script>
  import { HTTP } from '../http.js'
  import { BreedingRhombusSpinner } from 'epic-spinners'
  import { Slider } from 'vue-color'
  import commandsView from './views/commandsView'

  export default {
    name: 'scenarion',
    components: {
      BreedingRhombusSpinner,
      commandsView,
      'slider-picker': Slider
    },
    data () {
      return {
        id: 0,
        name: '',
        color: {},
        commands: [],
        saving: false,
        editing: false,
        icons: [],
        selectedIcon: '',
        showIcons: false
      }
    },
    created () {
      fetch('https://app.nexabridge.se/ikoner')
      .then(res => res.json())
      .then(json => this.icons = json)
      
      this.editing = ('id' in this.$route.params)
      
      if (this.editing) {
        const scenario = this.$root.data.scenarios.find(scenario => scenario.id === this.$route.params.id)
        
        this.id = scenario.id
        this.name = scenario.name
        this.color = { hex: scenario.color }
        this.commands = scenario.commands
        this.selectedIcon = scenario.iconURL
      }
    },
    methods: {
      iconStyle (icon) {
        return {
          'width':'55px',
          'height':'55px',
          'cursor':'pointer',
          'text-align':'center',
          'border':'1px solid ' + (icon === this.selectedIcon ? this.color.hex : '#fff'),
          'padding':'8px',
          'border-radius':'4px'
        }
      },
      
      save () {
        let obj = {
          name: this.name,
          color: this.color.hex || '#000',
          favorite: false,
          commands: this.commands,
          iconURL: 'https://cdn-nexabridge.ams3.cdn.digitaloceanspaces.com/external/ikoner/default.png'
        }
        
        // Om man har valt en ikon så sätter vi den här
        if (this.selectedIcon.length) {
          obj.iconURL = this.selectedIcon
        }
        
        this.saving = true
        
        let path = 'scenarios'
        if (this.editing) {
          path += '/' + this.id
        }
        
        HTTP.post(path, obj)
        .then(res => res.data)
        .then(json => {
          this.saving = false
          
          if (this.editing) {
            let scenario = this.$root.data.scenarios.find(scenario => scenario.id === this.$route.params.id)
            
            scenario.name = this.name
            scenario.color = this.color.hex || '#000'
            scenario.commands = this.commands
            scenario.iconURL = obj.iconURL
          } else {
            obj.id = json.id
            this.$root.data.scenarios.push(obj)
          }

          // Skicka vidare användaren
          this.$router.push({
            name: 'scenarion'
          })          
        })
      },
      
      // Radera scenariot från Bridgen
      remove () {
        if (confirm('Är du säker på att du vill radera scenariot?')) {
          // Radera från vår lista och därför vy
          const index = this.$root.data.scenarios.findIndex(scenario => scenario.id === this.id)
          this.$root.data.scenarios.splice(index, 1)
          
          // Radera från Bridgen
          HTTP.delete('scenarios/' + this.id)
          
          // Skicka vidare användaren
          this.$router.push({
            name: 'scenarion'
          })  
        }
      }
    },
    computed: {
      ok () {
        return (this.name.length && Object.keys(this.color).length && this.commands.length && this.selectedIcon.length) && !this.saving
      }
    },
    destroyed () {}
  }
</script>



// WEBPACK FOOTER //
// src/components/scenarion_ny.vue